import {normalizeEnumKey} from "../../i18n/labelHelpers";
import type {StatusTone} from "../../Components/ui/StatusTag";

export type ParticipantOperationsVariables = {
    eventId: number;
    participantId: number;
};

export type ParticipantOperationsRegistrationPayerLookup = {
    id: number;
    payerEmail?: string | null;
};

export const EMPTY_OPERATIONS_VALUE = "-";

export const buildParticipantOperationsVariables = (
    eventId: number,
    participantId: number
): ParticipantOperationsVariables => ({
    eventId,
    participantId
});

export const buildParticipantOperationsOfferDownloadUrl = (eventId: number, offerId: number) =>
    `/api/events/${eventId}/offers/${offerId}/download`;

export const buildParticipantOperationsOfferResendUrl = (eventId: number, offerId: number) =>
    `/api/events/${eventId}/offers/${offerId}/resend`;

export const buildParticipantOperationsCustomerPurchaseOrderUploadUrl = (eventId: number, offerId: number) =>
    `/api/events/${eventId}/offers/${offerId}/customer-purchase-order`;

export const buildParticipantOperationsCustomerPurchaseOrderDownloadUrl = (eventId: number, offerId: number) =>
    `/api/events/${eventId}/offers/${offerId}/customer-purchase-order/download`;

export const buildParticipantOperationsFileDownloadUrl = (fileId: number) =>
    `/api/File/Download/${fileId}`;

export const getParticipantOperationsOfferPayerEmail = (
    registrations: ParticipantOperationsRegistrationPayerLookup[],
    registrationId: number
) => registrations.find(registration => registration.id === registrationId)?.payerEmail?.trim() || EMPTY_OPERATIONS_VALUE;

export const toGraphqlEventRegistrationStatus = (value: string) => normalizeEnumKey(value);

export const operationalPaymentStatusTone = (status?: string | null): StatusTone => {
    switch (normalizeEnumKey(status)) {
    case "PAID":
    case "MANUALLY_RECONCILED":
        return "success";
    case "PENDING":
        return "warning";
    case "FAILED":
    case "CANCELLED":
    case "REFUNDED":
        return "error";
    default:
        return "neutral";
    }
};

export const operationalOfferStatusTone = (status?: string | null): StatusTone => {
    switch (normalizeEnumKey(status)) {
    case "EMAILED":
        return "success";
    case "QUEUED":
        return "info";
    case "GENERATED":
        return "info";
    case "EXPIRED":
        return "warning";
    case "REPLACED":
        return "neutral";
    case "FAILED":
        return "error";
    default:
        return "neutral";
    }
};

export const operationalRoomReservationStatusTone = (status?: string | null): StatusTone => {
    switch (normalizeEnumKey(status)) {
    case "RESERVED":
        return "info";
    case "RELEASED":
        return "neutral";
    case "CANCELLED":
        return "error";
    default:
        return "neutral";
    }
};

export const operationalRegistrationCodeStatusTone = (isActive: boolean): StatusTone => isActive ? "success" : "neutral";

export const operationalCertificateStatusTone = (status?: string | null): StatusTone => {
    switch (normalizeEnumKey(status)) {
    case "EMAILED":
        return "success";
    case "QUEUED":
        return "info";
    case "GENERATED":
        return "info";
    case "FAILED":
        return "error";
    default:
        return "neutral";
    }
};

export const canGenerateCertificateForRegistration = (registrationStatus?: string | null) =>
    ["REGISTRIRAN", "POTVRDEN"].includes(normalizeEnumKey(registrationStatus));
